import { render } from "./FriendsAdd.vue?vue&type=template&id=f92df8ce&scoped=true"
import script from "./FriendsAdd.vue?vue&type=script&lang=js"
export * from "./FriendsAdd.vue?vue&type=script&lang=js"

import "./FriendsAdd.vue?vue&type=style&index=0&id=f92df8ce&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f92df8ce"]])

export default __exports__